import { combineReducers } from 'redux';

import {
  ACTION_LOAD_PAYOUT_REQUEST_DETAILS__SUCCESS,
} from '../../actionTypes';

import errors from './errors';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_PAYOUT_REQUEST_DETAILS__SUCCESS:
      return {
        ...state,
        [action.payload.payoutRequestDetails.id]: action.payload.payoutRequestDetails,
      };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  errors,
});
